import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationType } from 'src/app/enum/NotificationType';
import { MenuListItems } from 'src/app/Models/ModelsList/menuListItem';
import { MenuModel } from 'src/app/Models/menuModel';
import { SourceIdEnum } from 'src/app/Models/sourceIdEnumModel';
import { FreeDemoRegistrationComponent } from 'src/app/popupModel/free-demo-registration/free-demo-registration.component';
import { CacheService } from 'src/app/services/cache.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ProductService } from 'src/app/services/product.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserService } from 'src/app/services/user.service';
import { StorageKey, StorageType } from 'src/app/storage-key';
import { LoginWithEmailComponent } from 'src/app/popupModel/login-with-email/login-with-email.component';
import { ChangePasswordComponent } from 'src/app/popupModel/change-password/change-password.component';
import { DOCUMENT } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { SourceIdResolverService } from 'src/app/services/source-id-resolver.service';
import { NRIModel } from 'src/app/Models/NRIModel';
import { HomeService } from 'src/app/services/home.service';
import { NRIListItems } from 'src/app/Models/ModelsList/homeNriList';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  // styleUrls: ['./headerNew.component.css'],
})
export class HeaderComponent implements OnInit {
  r2PublicBaseUrl = environment.r2PublicBaseUrl;
  readonly defaultProfileImage = '/assets/images/profile_avatar.png';
  private readonly profileImageBaseUrl = (environment as any).r2PublicBaseUrl || 'https://files.askiitians.com';
  toggleMobileMenu: boolean = false;
  isLogin: boolean = false;
  expandMenu: boolean = false;
  isVerticalLayout = true;
  mobileActiveMenu: string = 'menu';
  dekstopActiveMenu: string = '';
  userDetails: any;
  menuItems: Array<MenuModel> = [] as Array<MenuModel>;
  notesmenuItems: Array<MenuModel> = [] as Array<MenuModel>;
  scrollingClass: string = '';
  productData: any;
  isPackage: boolean = false;
  Appgradeid: any;
  currentRoute!: string;
  ifHome: boolean = false;
  showUserMenu: boolean = false;
  show = false;
  showCentersMenu: boolean = false;
  cachaSubscribe: any;
  parentList: boolean = false;
  childList: boolean = false;
  hideSideNav: boolean = false;
  subscriptionPackages: any;
  isPaid: boolean = false;
  centerMenuItems: Array<NRIModel> = [] as Array<NRIModel>;
  activeCenterId: string = '';
  centerPagesById: { [key: string]: any[] } = {};
  centerPagesLoaded: { [key: string]: boolean } = {};
  centerMenuLoading: boolean = false;

  constructor(
    private modalService: NgbModal,
    private cachaService: CacheService,
    private router: Router,
    private storage: StorageService,
    private userService: UserService,
    private productService: ProductService,
    private homeService: HomeService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private sourceIdResolver: SourceIdResolverService,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private dom: any
  ) {}

  ngOnInit(): void {
    let IsLogin = this.storage.getItem(StorageKey.IS_LOGGED_IN, StorageType.LOCAL);
    this.isLogin = Boolean(IsLogin);
    this.ifHome = this.isLogin;

    this.cachaSubscribe = this.cachaService._userDetails.subscribe((res) => {
      this.isLogin = res != null;
      this.ifHome = this.isLogin;
      this.userDetails = res;
      if (res != null) {
        const userId = this.resolveUserId(res);
        if (userId === null) {
          return;
        }

        this.getUserOrders(userId);
        this.userService.getUserFromID(userId).subscribe((res) => {
          if (res) {
            this.userDetails = { ...this.userDetails, ...res };
            this.storage.setItem(StorageKey.USER, JSON.stringify(this.userDetails), StorageType.LOCAL);
          }

          // this.isPaid = res.userdetails.isPaid;
          if (res?.userdetails)
          {
            if (res.userdetails.isPaid == true) {
              this.cachaService.seIsPaidUser(true);
            } else {
              this.cachaService.seIsPaidUser(false);
            }
          }
        });
      }
    });

    this.cachaService._isUserLoggedIn.subscribe((res) => {
      this.isLogin = res;
      if (this.isLogin == false) {
        if (this.storage.getItem(StorageKey.IS_LOGGED_IN, StorageType.LOCAL) == 'true') {
          this.isLogin = true;
        }
      }
    });

    this.centerMenuItems = NRIListItems.NRIItems;
    if (this.centerMenuItems.length > 0 && this.centerMenuItems[0].dataId) {
      this.activeCenterId = this.centerMenuItems[0].dataId;
      this.loadCenterPages(this.activeCenterId);
    }
  }

  copyPhoneNumber(event: MouseEvent): void {
    event.preventDefault();

    const phoneNumber = '+91 87964 74404';
    const clipboard = this.dom?.defaultView?.navigator?.clipboard;

    if (clipboard?.writeText) {
      clipboard.writeText(phoneNumber).catch(() => this.copyPhoneNumberFallback(phoneNumber));
      return;
    }

    this.copyPhoneNumberFallback(phoneNumber);
  }

  private copyPhoneNumberFallback(phoneNumber: string): void {
    const input = this.dom.createElement('textarea');
    input.value = phoneNumber;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';

    this.dom.body.appendChild(input);
    input.select();
    this.dom.execCommand('copy');
    this.dom.body.removeChild(input);
  }

  getUserOrders(userId: number) {
    this.productService.getOrderFromUserID(userId).subscribe((data) => {
      this.productData = data.items;
      for (const item of this.productData) {
        if (
          item.userId === userId &&
          item.transactionId > 0
          // &&
          // item.packagedetail &&
          // item.packagedetail.length > 0
        ) {
          this.isPackage = true;
          // this.Appgradeid = item.packagedetail[0].gradeid;
          // this.cachaService.seIsPaidUser(true);
        } else {
          // this.cachaService.seIsPaidUser(false);
        }
      }
    });
  }

  private resolveUserId(user: any): number | null {
    const userId = Number(user?.id ?? user?.userId ?? user?.Id ?? user?.UserId);
    return Number.isFinite(userId) && userId > 0 ? userId : null;
  }

  ngOnDestroy() {
    this.cachaSubscribe.unsubscribe();
  }

  get profileImageUrl(): string {
    return this.resolveProfileImageUrl(
      this.userDetails?.userdetails?.imagePath || this.userDetails?.userDetails?.imagePath || this.userDetails?.imagePath
    );
  }

  onProfileImageError(event: Event): void {
    (event.target as HTMLImageElement).src = this.defaultProfileImage;
  }

  private resolveProfileImageUrl(imagePath?: string): string {
    const trimmedPath = imagePath?.trim();

    if (!trimmedPath) {
      return this.defaultProfileImage;
    }

    if (/^(data:|blob:)/i.test(trimmedPath) || trimmedPath.startsWith('/assets/') || trimmedPath.startsWith('assets/')) {
      return trimmedPath;
    }

    if (/^https?:\/\//i.test(trimmedPath) && !/files\.askiitians\.com/i.test(trimmedPath)) {
      return trimmedPath;
    }

    const normalizedPath = trimmedPath
      .replace(/^https?:\/\//i, '')
      .replace(/^\/+/, '')
      .replace(/^files\.askiitians\.com\//i, '')
      .replace(/^static-content\//i, 'static_content/')
      .replace(/\/static-content\//gi, '/static_content/');

    if (!normalizedPath) {
      return this.defaultProfileImage;
    }

    return `${this.profileImageBaseUrl.replace(/\/$/, '')}/${normalizedPath}`;
  }

  expandUserMenu() {
    this.isVerticalLayout = !this.isVerticalLayout;
    this.cachaService.onExpandUserMenu(this.expandMenu);
  }

  toggleUserMenu(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.showUserMenu = !this.showUserMenu;
    this.closeSideNav();
    this.show = false;
    this.showCentersMenu = false;
  }

  closeUserMenu(event?: MouseEvent) {
    event?.stopPropagation();
    this.showUserMenu = false;
  }

  openlogin() {
    this.router.navigate(['/login-signup'], {
      state: { sourceId: this.router.url === '/' ? SourceIdEnum.Login : this.sourceIdResolver.resolve(this.router.url) },
    });
  }

  logout() {
    this.authService.logout();
    this.storage.clear(StorageType.LOCAL);
    this.router.navigate(['']);
    this.notificationService.notifyMessage(NotificationType.Success, `You're successfully logged out!`);
  }

  onclick_exam_info() {
    this.show = false;
  }
  onclick_notes() {
    this.show = false;
  }

  over_notes() {
    this.show = !this.show;
    if (this.show) {
      this.notesmenuItems = MenuListItems.NotesMenuItems;
    } else {
      this.notesmenuItems = [];
    }
  }

  over_exam() {
    if (this.show) {
      this.menuItems = MenuListItems.MenuItems;
    } else {
      this.menuItems = [];
    }
  }

  toggleParentList() {
    this.parentList = true;
    if (this.parentList) {
      this.childList = true;
    } else {
      this.childList = false;
    }
  }

  toggleChildList() {
    this.childList = true;
  }
  loadchildList() {
    this.childList = true;
  }

  onMouseEnterOnExamInfo() {
    this.menuItems = MenuListItems.MenuItems;
    this.show = true;
    this.childList = true;
  }

  onMouseEnterOnNotes() {
    this.notesmenuItems = MenuListItems.NotesMenuItems;
    this.show = true;
  }

  openCentersMenu() {
    this.showCentersMenu = true;
    this.show = false;
    if (!this.activeCenterId && this.centerMenuItems.length > 0 && this.centerMenuItems[0].dataId) {
      this.selectCenter(this.centerMenuItems[0].dataId);
    }
  }

  toggleCentersMenu(event?: Event) {
    event?.preventDefault();
    this.showCentersMenu = !this.showCentersMenu;
    this.show = false;
    if (this.showCentersMenu && !this.activeCenterId && this.centerMenuItems.length > 0 && this.centerMenuItems[0].dataId) {
      this.selectCenter(this.centerMenuItems[0].dataId);
    }
  }

  closeCentersMenu() {
    this.showCentersMenu = false;
  }

  selectCenter(centerId: string) {
    this.activeCenterId = centerId;
    if (!this.centerPagesLoaded[centerId]) {
      this.loadCenterPages(centerId);
    }
  }

  loadCenterPages(centerId: string) {
    if (!centerId || this.centerPagesLoaded[centerId]) {
      return;
    }

    this.centerMenuLoading = true;
    this.homeService.getNRIPost(centerId).subscribe({
      next: (res) => {
        this.centerPagesById[centerId] = this.normalizeCenterPages(res);
        this.centerPagesLoaded[centerId] = true;
        this.centerMenuLoading = false;
      },
      error: () => {
        this.centerPagesById[centerId] = [];
        this.centerPagesLoaded[centerId] = false;
        this.centerMenuLoading = false;
      },
    });
  }

  getCenterPages(centerId: string): any[] {
    return this.centerPagesById[centerId] || [];
  }

  private normalizeCenterPages(res: any): any[] {
    const parsedResponse = this.tryParseJson(res);
    const pageRecords = this.findPageRecords(parsedResponse);

    if (pageRecords.length > 0) {
      return pageRecords;
    }

    if (Array.isArray(parsedResponse)) {
      return parsedResponse;
    }

    if (Array.isArray(parsedResponse?.items)) {
      return parsedResponse.items;
    }

    if (Array.isArray(parsedResponse?.data)) {
      return parsedResponse.data;
    }

    return [];
  }

  private tryParseJson(value: any): any {
    if (typeof value !== 'string') {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  private findPageRecords(value: any): any[] {
    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      if (value.every((item) => this.isNriPageRecord(item))) {
        return value;
      }

      for (const item of value) {
        const nested = this.findPageRecords(item);
        if (nested.length > 0) {
          return nested;
        }
      }

      return [];
    }

    if (typeof value === 'object') {
      if (this.isNriPageRecord(value)) {
        return [value];
      }

      for (const key of Object.keys(value)) {
        const nested = this.findPageRecords(value[key]);
        if (nested.length > 0) {
          return nested;
        }
      }
    }

    return [];
  }

  private isNriPageRecord(value: any): boolean {
    return !!value && typeof value === 'object' && typeof value.title === 'string' && typeof value.source === 'string';
  }

  getCenterSlug(center: NRIModel): string {
    const centerName = (center.stringValue || '').trim().toLowerCase();
    const slugMap: { [key: string]: string } = {
      bahrain: 'bahrain',
      indonesia: 'indonesia',
      kuwait: 'kuwait',
      malaysia: 'malaysia',
      oman: 'oman',
      qatar: 'qatar',
      'saudi arabia': 'saudi-arabia',
      singapore: 'singapore',
      uae: 'uae',
      uganda: 'uganda',
      usa: 'usa',
      india: 'india',
    };

    return slugMap[centerName] || centerName.replace(/\s+/g, '-');
  }

  getCenterPageUrl(page: any): string {
    return page?.source ? page.source.replace('~', '') : 'javascript:void(0);';
  }

  getCenterPageExcerpt(page: any): string {
    const rawExcerpt = page?.excerpt || page?.excerpt?.rendered || '';
    const plainExcerpt = String(rawExcerpt).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    return plainExcerpt;
  }

  onCenterPageClick() {
    this.toggleMobileMenu = false;
    this.dekstopActiveMenu = 'our-center';
    this.closeCentersMenu();
  }

  bookAFreeClass() {
    if (!this.userDetails) {
      const sourceId = SourceIdEnum.Register;
      this.router.navigate(['/login-signup'], { queryParams: { returnUrl: this.router.url }, state: { sourceId } });
      // const modalRef = this.modalService.open(LoginWithEmailComponent, { centered: true, backdrop: 'static',
      // windowClass: 'login-modal-window' });
      // modalRef.componentInstance.sourceId = sourceId;
    } else {
      const sourceId = SourceIdEnum.FreeDemo;
      const modalRef = this.modalService.open(FreeDemoRegistrationComponent, { centered: true, backdrop: 'static' });
      modalRef.componentInstance.UserName = this.userDetails.name;
      modalRef.componentInstance.Phone = this.userDetails.mobile;
      modalRef.componentInstance.sourceId = sourceId;
    }
  }

  receiveDataFromChild(data: boolean) {
    this.toggleMobileMenu = data;
  }

  manageSideNav(eventData: any) {
    // changes on header html file
    this.expandMenu = !this.expandMenu;
  }

  closeSideNav() {
    this.expandMenu = false;
    this.cachaService.closeSideNavigation(false);
  }
  ChangePassword() {
    const ChangePasswordModalRef = this.modalService.open(ChangePasswordComponent, {
      centered: true,
      backdrop: 'static',
    });
  }
  Subscription() {
    this.router.navigate(['subscriptions']);
  }
}
